import { TypedUseSelectorHook, useSelector } from "react-redux";
import type { RootState } from "State/store";

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
